module.exports = __webpack_public_path__ + "stu-res/img/course-4.4e39183f.png";